import { Parser } from '@json2csv/plainjs'

import { downloadFile } from './download'

interface FieldsProps {
  label: string
  path: string
}

const DEFAULT_OPTIONS = {
  filename: 'export-csv',
}

export async function exportDataToCSV<DataType>(
  data: DataType[],
  fields: FieldsProps[],
  options: { filename: string } = DEFAULT_OPTIONS,
) {
  try {
    const parser = new Parser({ fields: fields.map(field => field.path) })
    const csvData = parser.parse(data || [])
    const uri = `data:text/csv;charset=utf-8,${encodeURIComponent(csvData)}`
    await downloadFile(uri, `${options.filename}.csv`)
  } catch (err) {
    console.error(err)
    throw Error('Error while exporting data to CSV')
  }
}
